import { render, staticRenderFns } from "./MainHeader.vue?vue&type=template&id=0368ba0b&scoped=true"
import script from "./MainHeader.vue?vue&type=script&lang=ts"
export * from "./MainHeader.vue?vue&type=script&lang=ts"
import style0 from "./MainHeader.vue?vue&type=style&index=0&id=0368ba0b&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0368ba0b",
  null
  
)

export default component.exports